import { apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
  methods: {

    async apiLogin () {
      this.logando = true
      this.errmessages = null

      SysVars.appBlocked = false
      SysVars.appEndTrial = false
      SysVars.appLogged = false

      var sendData = { login: { email: this.email.toLowerCase(), senha: this.senha } }
      const login = await apiORDSapp(this, 'login/', 'post', sendData)
      if (login.errmessages) {
        this.errmessages = login.errmessages
        this.logando = false
        return
      } else if (login.status == 'invalid') {
          this.errmessages = login.message
          this.logando = false
          return
      }

      // BFF flow returns token already nested in login.auth
      this.apiLoginToken(login)
    },


    async apiLoginToken (login) {
      this.errmessages = null

      // Read auth token nested in the login response (Standard BFF) 
      // Or construct it from the flat 'token' query value (Autologin BFF)
      const auth = login.auth || (login.token ? { access_token: login.token, token_type: 'bearer' } : null)
      
      this.logando = false
      if (!auth || !auth.access_token) {
        this.$erpToastError('Falha na autenticação (Token não gerado pelo BFF)')
        return
      }

      const authObj = { auth: auth, login: login }
      this.$store.dispatch('loadEnv', authObj )

      if (login.isblocked)
        SysVars.appBlocked = true
      else
      if (login.isendtrial)
        SysVars.appEndTrial = true

      SysVars.appLogged = true

      // Limpa o token_autologin da URL (antes do hash #)
      if (window.location.search.includes("token_autologin")) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("token_autologin");
        window.history.replaceState(
          {},
          "",
          cleanUrl.pathname + cleanUrl.search + cleanUrl.hash
        );
      }

      if (login.tpempresa === 'E') {
        this.$router.push({ name: 'contador_empresas' });
      } else {
        if (this.$route.name == 'registro' || this.$route.name == 'registropedidos' || this.$route.name == 'registroloja') {
          window.location.href = '/'
        } else {
          this.$emit('closeform')
        }
      }
    },

    async apiLoginNewAccount () {

      var sendData = { login: { email: this.email.toLowerCase() } }
      const login = await apiORDSapp(this, 'tokennewaccount/', 'post', sendData)
      if (login.errmessages) {
        this.errmessages = login.errmessages
        this.logando = false
        return
      } else if (login.status == 'invalid') {
          this.errmessages = login.message
          this.logando = false
          return
      }


      this.apiLoginToken(login)

    },




  }
}





// WEBPACK FOOTER //
// ./src/api/api-login.js